<template>
  <div id="btnAddManagerClient">
    <v-menu
      v-model="menu"
      offset-x
      min-width="500px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnAddManagerClient"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          class="ma-1"
          v-on="on"
        >
          Додати клієнта
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <ClientSelect
            v-model="client"
            label="Клієнт"
            :clearable="true"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :disabled="!client"
            @click="add()"
          >
            OK
          </v-btn>
          <v-btn
            text
            @click="cancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ClientSelect from "@/components/selects/ClientSelect";

export default {
  components: {
    ClientSelect,
  },
  data: () => ({
    menu: false,
    client: null,
  }),
  methods: {
    add() {
      this.$emit("apply", this.client);
      this.cancel();
    },
    cancel() {
      this.client = null;
      this.menu = false;
    },
  },
};
</script>